import { createApp } from 'vue'
import App from './views/App.vue'
import router from './router'
import { createMetaManager } from 'vue-meta'

const app = createApp(App)
    .use(router)
    .use(createMetaManager())

await router.isReady()
app.mount('#app')